import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../styles/footer.module.scss";

export const FooterModuleBettingDisclosure = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderBettingDisclosure, bettingAffDisclosureHeader, bettingGambleResponsibleHeader, bettingDisclosureText} = state;

  if (!shouldRenderBettingDisclosure) {
    return null;
  }

  return (
    <div className={classNames(styles.betting_disclosure)}>
      <div className={classNames(styles.betting_disclosure_header)}>{bettingAffDisclosureHeader}</div>
      <div className={classNames(styles.betting_disclosure_text)}>{bettingDisclosureText}</div>
      <div className={classNames(styles.betting_disclosure_header)}>{bettingGambleResponsibleHeader}</div>
    </div>
  );
});
